module.exports = __webpack_public_path__ + "static/tactics_notebook_tablet_volejball-2ee0e8f80163195e61ba5744d920e322.mp4";